var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayoutThird = function SvgLayoutThird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.563 3.438h.773a.773.773 0 0 0-.773-.774zm0 15.125v.773a.773.773 0 0 0 .773-.773zm-15.125 0h-.774c0 .427.346.773.773.773zm0-15.125v-.774a.773.773 0 0 0-.774.773zm15.125 0h-.774v15.125h1.547V3.438zm0 15.125v-.774H3.438v1.547h15.125zm-15.125 0h.773V3.438H2.664v15.125zm0-15.125v.773h15.125V2.664H3.438z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.563 14.297h.773V12.75h-.773v1.5470000000000002M3.438 12.75h-.774v1.547h.773V12.75m0 .774v.773h15.125V12.75H3.438zM18.563 9.25h.773V7.703h-.773V9.25M3.438 7.703h-.774V9.25h.773V7.703m0 .773v.774h15.125V7.703H3.438z"
  })));
};
export default SvgLayoutThird;